import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiSad3dSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g filter={`url(#${_uniqueId}filter0_i_8745_24)`} suppressHydrationWarning>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 1.333C3.167 1.333 1.333 3.167 1.333 16S3.167 30.667 16 30.667 30.667 28.833 30.667 16 28.833 1.333 16 1.333m-3.392 21.928c-.49.523-.742 1.124-.742 1.739h-2.4c0-1.307.543-2.478 1.392-3.381 1.224-1.304 3.102-2.086 5.142-2.086s3.918.782 5.142 2.085c.848.904 1.391 2.075 1.391 3.382h-2.4c0-.615-.25-1.216-.74-1.739-.723-.769-1.943-1.328-3.393-1.328s-2.67.559-3.392 1.328m10.725-9.394H18v-2.4h5.333zm-14.666 0H14v-2.4H8.666z"
                    fill={`url(#${_uniqueId}paint0_radial_8745_24)`}
                    suppressHydrationWarning
                />
                <path
                    d="M14 13.867H8.666v-2.4H14z"
                    fill={`url(#${_uniqueId}paint1_radial_8745_24)`}
                    suppressHydrationWarning
                />
                <path
                    d="M18 13.867h5.333v-2.4H18z"
                    fill={`url(#${_uniqueId}paint2_radial_8745_24)`}
                    suppressHydrationWarning
                />
                <path
                    d="M11.867 25c0-.615.25-1.216.74-1.739.723-.769 1.943-1.328 3.393-1.328s2.67.559 3.392 1.328c.49.523.741 1.124.741 1.739h2.4c0-1.307-.543-2.478-1.391-3.381-1.224-1.304-3.102-2.086-5.142-2.086s-3.918.782-5.142 2.085c-.849.904-1.391 2.075-1.391 3.382z"
                    fill={`url(#${_uniqueId}paint3_radial_8745_24)`}
                    suppressHydrationWarning
                />
            </g>
            <path d="M14 13.867H8.667v-2.4H14z" fill="#79610C" />
            <path d="M18 13.867h5.334v-2.4H18z" fill="#79610C" />
            <path
                d="M11.867 25c0-.614.25-1.216.74-1.739.723-.769 1.943-1.328 3.393-1.328s2.67.559 3.392 1.328c.49.523.742 1.125.742 1.739h2.4c0-1.307-.543-2.477-1.392-3.381-1.224-1.304-3.102-2.086-5.142-2.086s-3.918.782-5.142 2.086c-.848.904-1.391 2.074-1.391 3.381z"
                fill="#79610C"
            />
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_24`}
                    x={1.333}
                    y={-3.667}
                    width={34.333}
                    height={34.333}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={5} dy={-5} />
                    <feGaussianBlur stdDeviation={5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_24" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_24`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(9.72058 6.83325) rotate(52.125) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint1_radial_8745_24`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(9.72058 6.83325) rotate(52.125) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint2_radial_8745_24`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(9.72058 6.83325) rotate(52.125) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint3_radial_8745_24`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(9.72058 6.83325) rotate(52.125) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiSad3dSize32Glyph.displayName = 'EmojiSad3dSize32Glyph';
